import { render, staticRenderFns } from "./WhatsappParametrizacao.vue?vue&type=template&id=2dcf2195&"
import script from "./WhatsappParametrizacao.vue?vue&type=script&lang=js&"
export * from "./WhatsappParametrizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports